import React, { useState, useEffect, useRef } from 'react';
import api from '../api/client';

// Per-type settings modal (Production Plan). Form state stays here so typing never re-renders the grid.
// PUT /plantoproduce/type-settings/:type → onSaved(type, { workstations, employees, instruction }).

const toInt = s => (String(s).trim() === '' ? null : Number(s));
const fromInt = v => (v == null ? '' : String(v));

const TypeSettingsModal = ({ type, label, initial, onClose, onSaved }) => {
  const [ws, setWs] = useState(fromInt(initial && initial.workstations));
  const [emp, setEmp] = useState(fromInt(initial && initial.employees));
  const [instruction, setInstruction] = useState((initial && initial.instruction) || '');
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState(null);
  const downOnOverlay = useRef(false); // close only when mousedown AND click land on the overlay (drag-select from the textarea must not close)

  useEffect(() => {
    const onKey = e => { if (e.key === 'Escape' && !saving) onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose, saving]);

  // Workstations come from the stations dictionary (Assignments → Settings) when the type has
  // any: shown read-only, not sent. The manual number stays only for types without stations (kits).
  const st = (initial && initial.stations) || null;
  const fromStations = !!(st && st.count > 0);

  const save = async () => {
    const body = { employees: toInt(emp), instruction, ...(fromStations ? {} : { workstations: toInt(ws) }) };
    setSaving(true);
    setErr(null);
    try {
      await api.put(`/plantoproduce/type-settings/${type}`, body);
      onSaved(type, body);
    } catch (e) {
      console.error('Error saving type settings:', e);
      setErr((e.response && e.response.data && e.response.data.error) || 'Failed to save');
      setSaving(false);
    }
  };

  return (
    <div className="pp-modal-overlay"
         onMouseDown={e => { downOnOverlay.current = e.target === e.currentTarget; }}
         onClick={e => { if (downOnOverlay.current && e.target === e.currentTarget && !saving) onClose(); }}>
      <div className="pp-modal">
        <div className="pp-modal-title">{label} — settings</div>
        <div className="pp-modal-row">
          {fromStations
            ? <label>Workstations<div className="pp-ts-stations" title="Managed in Assignments → Settings → Stations & machines"><b>{st.count}</b> active · {st.labels.join(', ')}</div></label>
            : <label>Workstations<input type="number" min="0" value={ws} autoFocus onChange={e => setWs(e.target.value)} /></label>}
          <label>Employees<input type="number" min="0" value={emp} autoFocus={fromStations} onChange={e => setEmp(e.target.value)} /></label>
        </div>
        <label>Instruction<textarea rows={8} value={instruction} onChange={e => setInstruction(e.target.value)} /></label>
        {err && <div className="pp-modal-err">{err}</div>}
        <div className="pp-modal-actions">
          <button className="pp-btn" onClick={onClose} disabled={saving}>Cancel</button>
          <button className="pp-btn pp-btn-primary" onClick={save} disabled={saving}>{saving ? 'Saving…' : 'Save'}</button>
        </div>
      </div>
    </div>
  );
};

export default TypeSettingsModal;
